<article>
  <form [formGroup]="maintenanceForm">
    <mat-radio-group class="flex-column gap-16 mb-24" formControlName="type" *ngIf="!createItemMode">
      <mat-radio-button *ngFor="let maintenanceType of maintenanceTypes" [value]="maintenanceType">
        {{ 'PLANNING.ADD_ITEM.TYPES.' + maintenanceType | bmsTranslate }}
      </mat-radio-button>
    </mat-radio-group>

    <app-planning-item-date-select
      vdwDelayedClass="blurry-content-fix"
      [earliestStartDateControl]="maintenanceForm.controls.earliestStartDate"
      [minimumDurationControl]="maintenanceForm.controls.minimumDuration"
      class="mt-24"
    ></app-planning-item-date-select>
  </form>
</article>

<footer>
  <ng-container *ngIf="!createItemMode">
    <div class="button-skeleton-wrapper raised-btn">
      <button mat-icon-button class="mat-icon-action-button-lg-with-border" (click)="delete()" [matTooltip]="'GENERAL.ACTIONS.DELETE' | bmsTranslate">
        <mat-icon svgIcon="trash"></mat-icon>
      </button>
    </div>

    <div class="button-skeleton-wrapper raised-btn">
      <button mat-flat-button color="primary" (click)="saveChanges()">
        {{ 'GENERAL.ACTIONS.SAVE' | bmsTranslate }}
      </button>
    </div>
  </ng-container>

  <button mat-flat-button color="primary" (click)="createItem()" *ngIf="createItemMode">
    {{ 'GENERAL.ACTIONS.CREATE' | bmsTranslate }}
  </button>
</footer>
